window.addEventListener('DOMContentLoaded', (event) => {
  
  if (!customElements.get('sticky-add-to-cart')) {
    customElements.define(
      'sticky-add-to-cart',
      class StickyAddToCart extends HTMLElement {
  
        constructor() {
          super();
  
          var selectors = {
            "scrollTop": "[data-scroll-top]",
            "mobileStickyBar": "[data-mobile-sticky-bar]",
            "mobileToggle": "[data-product-sticky-toggle]"
          }
  
          // Define top position
          function defineTopPosition(self) {

            let stickyHeader = document.querySelector('.main-header-section .active-sticky');
            let stickyAnnouncementBar = document.querySelector('#AnnouncementBar.active-sticky');
      
            // Check if Hypnia kids is active
            const hypniaKidsStatus = document.documentElement.getAttribute('data-hypnia-kids')
            if (hypniaKidsStatus === 'active') {
              stickyHeader = document.querySelector('.main-header-section .kids-active-sticky');
              stickyAnnouncementBar = document.querySelector('#AnnouncementBar.kids-active-sticky');
            }
      
            let topPosition = 0;
            if (stickyAnnouncementBar) {
              topPosition = topPosition + stickyAnnouncementBar.parentElement.offsetHeight;
            }
            if (stickyHeader) {
              topPosition = topPosition + stickyHeader.parentElement.offsetHeight;
            }

            if (topPosition > 0) {
              self.parentElement.style.top = (topPosition-1) + 'px';
              self.parentElement.classList.add('active');
            }

          }

          const _self = this;
          defineTopPosition(_self);
          window.addEventListener('load', function() {
            defineTopPosition(_self);
          });
          window.addEventListener('kids-ready', function() {
            defineTopPosition(_self);
          });
          
  
          this.triggersScrollTop = this.querySelectorAll(selectors.scrollTop);
          this.triggersScrollTop.forEach((triggerScrollTop) => {
            triggerScrollTop.addEventListener(
              'click',
              this.scrollTop.bind(this),
            );
          });
  
          // === Mobile Sticky bar
  
          const mobileStickyBar = this.querySelector(selectors.mobileStickyBar);
          if (mobileStickyBar !== null && mobileStickyBar !== undefined) {
  
            // toggle mobile content
            const mobileToggle = this.querySelectorAll(selectors.mobileToggle);
            if (mobileToggle.length > 0) {
              mobileToggle.forEach(btn => {
                btn.addEventListener('click', (e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  this.toggleClassActive(mobileStickyBar);
                })
              });
            }
  
            // Init variants selector
            this.initVariantsSelector();
  
            // Init add to cart
            this.initAddToCart();
  
            // Init prices
            this.initPrices();
            
          }
  
        }
  
        scrollTop() {
  
          const mainProductForm = document.querySelector(`[data-product-main]`);
          let scrollTop = 0;
  
          if (mainProductForm !== null && mainProductForm !== undefined) {
            scrollTop = mainProductForm.offsetTop;
          }
  
          window.scroll({top: scrollTop, left: 0, behavior: 'smooth'});
  
        }
  
        toggleClassActive(elem) {
          if (elem !== null && elem !== undefined) {
            elem.classList.toggle('active');
            this.parentElement.classList.toggle('is-open');
          }
        }
  
        initVariantsSelector() {
  
          const thisVariantsSelectorWrapper = this.querySelector('[data-product-sticky-form-variants-selector]');
          const defaultVariantsSelector = document.querySelectorAll('variant-selectors variant-radios > .product-form__input, variant-selectors variant-selects > .product-form__input');
  
          if (thisVariantsSelectorWrapper !== null && thisVariantsSelectorWrapper !== undefined && defaultVariantsSelector.length > 0) {
  
            defaultVariantsSelector.forEach(defaultSelector => {
  
              const cloneDefaultSelector = defaultSelector.cloneNode(true);
  
              // change class
              cloneDefaultSelector.classList.remove('js','product-other-options');
  
              // Specials for variant-radios
              const cloneDefaultSelectorInputs = cloneDefaultSelector.querySelectorAll('input');
              const cloneDefaultSelectorLabels = cloneDefaultSelector.querySelectorAll('label');
              if (cloneDefaultSelectorInputs.length > 0 && cloneDefaultSelectorLabels.length > 0 && cloneDefaultSelectorInputs.length == cloneDefaultSelectorLabels.length) {
                cloneDefaultSelectorInputs.forEach((input,index) => {
                  input.id = 'custom-' + input.id;
                  input.setAttribute('form', 'product-sticky-form');
                  cloneDefaultSelectorLabels[index].htmlFor = 'custom-' + cloneDefaultSelectorLabels[index].htmlFor;
                  cloneDefaultSelectorLabels[index].removeAttribute('data-option');
                });
              }
  
              // Specials for variant-selects
              const cloneDefaultSelectorSelects = cloneDefaultSelector.querySelectorAll('select');
              if (cloneDefaultSelectorSelects.length > 0) {
                cloneDefaultSelectorSelects.forEach(select => {
                  select.id = 'custom-' + select.id;
                  select.setAttribute('form', 'product-sticky-form');
                });
              }
  
              thisVariantsSelectorWrapper.appendChild(cloneDefaultSelector);
  
              this.processVariantsSelector();
              this.defaultVariantsSelector();
              
            });
            
          }
  
        }
  
        processVariantsSelector() {
  
          const thisVariantsSelector = this.querySelectorAll('[data-product-sticky-form-variants-selector] .product-form__input');
          const defaultVariantsSelector = document.querySelectorAll('variant-selectors variant-radios > .product-form__input, variant-selectors variant-selects > .product-form__input');
  
          if (thisVariantsSelector.length > 0 && defaultVariantsSelector.length > 0) {
  
            // For variant-radios
            const thisVariantsSelectorInputs = this.querySelectorAll('[data-product-sticky-form-variants-selector] .product-form__input input');
            if (thisVariantsSelectorInputs.length > 0) {
              thisVariantsSelectorInputs.forEach(input => {
                input.addEventListener('click', () => {
                  const inputId = input.id.replace('custom-','');
                  const defaultInputMatch = document.querySelector(`variant-radios #${inputId}`);
                  if (defaultInputMatch !== null && defaultInputMatch !== undefined && defaultInputMatch.checked != true) {
                    defaultInputMatch.checked = true;
                    const parentElement = defaultInputMatch.closest('variant-selectors');
                    if (parentElement !== null && parentElement !== undefined) {
                      const inputEventChange = new Event("change");
                      parentElement.dispatchEvent(inputEventChange);
                    }
                  }
                });
              });
            }
  
            // For variant-selects
            const thisVariantsSelectorSelects = this.querySelectorAll('[data-product-sticky-form-variants-selector] .product-form__input select');
            if (thisVariantsSelectorSelects.length > 0) {
              thisVariantsSelectorSelects.forEach(select => {
                select.addEventListener('change', () => {
                  const selectId = select.id.replace('custom-','');
                  const selectValue = select.value;
                  const defaultSelectMatch = document.querySelector(`variant-selects #${selectId}`);
                  if (defaultSelectMatch !== null && defaultSelectMatch !== undefined) {
                    defaultSelectMatch.value = selectValue;
                    const parentElement = defaultSelectMatch.closest('variant-selectors');
                    if (parentElement !== null && parentElement !== undefined) {
                      const selectEventChange = new Event("change");
                      parentElement.dispatchEvent(selectEventChange);
                    }
                  }
                });
              });
            }
            
          }
  
        }
  
        defaultVariantsSelector() {
  
          const thisVariantsSelector = this.querySelectorAll('[data-product-sticky-form-variants-selector] .product-form__input');
          const defaultVariantsSelector = document.querySelectorAll('variant-selectors variant-radios > .product-form__input, variant-selectors variant-selects > .product-form__input');
  
          if (thisVariantsSelector.length > 0 && defaultVariantsSelector.length > 0) {
  
            // For variant-radios
            const defaultVariantsSelectorInputs = document.querySelectorAll('variant-selectors variant-radios .product-form__input input');
            if (defaultVariantsSelectorInputs.length > 0) {
              defaultVariantsSelectorInputs.forEach(input => {
                input.addEventListener('click', () => {
                  const inputId = 'custom-' + input.id;
                  const thisInputMatch = this.querySelector(`[data-product-sticky-form-variants-selector] #${inputId}`);
                  if (thisInputMatch !== null && thisInputMatch !== undefined && thisInputMatch.checked != true) {
                    thisInputMatch.checked = true;
                  }
                });
              });
            }
  
            // For variant-selects
            const defaultVariantsSelectorSelects = document.querySelectorAll('variant-selectors variant-selects .product-form__input select');
            if (defaultVariantsSelectorSelects.length > 0) {
              defaultVariantsSelectorSelects.forEach(select => {
                select.addEventListener('change', () => {
                  const selectId = 'custom-' + select.id;
                  const selectValue = select.value;
                  const thisSelectMatch = this.querySelector(`[data-product-sticky-form-variants-selector] #${selectId}`);
                  if (thisSelectMatch !== null && thisSelectMatch !== undefined) {
                    thisSelectMatch.value = selectValue;
                  }
                });
              });
            }
            
          }
  
        }
  
        initAddToCart() {
  
          const thisAddToCartWrapper = this.querySelector('[data-product-sticky-form-submit]');
          const defaultAddToCart = document.querySelector('product-form[data-main-product-form] button[type="submit"]');
  
          if (thisAddToCartWrapper !== null && thisAddToCartWrapper !== undefined && defaultAddToCart !== null && defaultAddToCart !== undefined) {
  
            const cloneDefaultAddToCart = defaultAddToCart.cloneNode(true);
  
            // Special change
            cloneDefaultAddToCart.setAttribute('type', 'button');
  
            // Insert in DOM
            thisAddToCartWrapper.innerHTML = '';
            thisAddToCartWrapper.appendChild(cloneDefaultAddToCart);
  
            // On default change
            this.onDefaultAddToCartChange();
  
            // Process Add To Cart
            this.processAddToCart();
            
          }
  
        }
  
        onDefaultAddToCartChange() {
  
          // DOM observer
          const observeDOM = (function(){
            let MutationObserver = window.MutationObserver || window.WebKitMutationObserver;
  
            return function( obj, callback ){
              if( !obj || obj.nodeType !== 1 ) return; 
  
              if( MutationObserver ){
                // define a new observer
                let mutationObserver = new MutationObserver(callback)
  
                // have the observer observe foo for changes in children
                mutationObserver.observe( obj, { childList:true, subtree:true })
                return mutationObserver
              }
              
              // browser support fallback
              else if( window.addEventListener ){
                obj.addEventListener('DOMNodeInserted', callback, false)
                obj.addEventListener('DOMNodeRemoved', callback, false)
              }
            }
          })();
  
          const defaultAddToCart = document.querySelector('product-form[data-main-product-form] button[type="submit"]');
          const _this = this;
  
          if (defaultAddToCart !== null && defaultAddToCart !== undefined) {
            observeDOM(defaultAddToCart, function(m){
              _this.initAddToCart();
            });
          }
  
        }
  
        processAddToCart() {
  
          const thisAddToCart = this.querySelector('[data-product-sticky-form-submit] button');
          const defaultAddToCart = document.querySelector('product-form[data-main-product-form] button[type="submit"]');
  
          if (thisAddToCart !== null && thisAddToCart !== undefined && defaultAddToCart !== null && defaultAddToCart !== undefined) {
  
            thisAddToCart.addEventListener('click', (e) => {
              e.preventDefault();
  
              // Add to cart
              defaultAddToCart.click();
  
              // Toggle sticky bar
              const mobileStickyBar = this.querySelector('[data-mobile-sticky-bar]');
              if (mobileStickyBar !== null && mobileStickyBar !== undefined) {
                this.toggleClassActive(mobileStickyBar);
              }
            });
            
          }
  
        }
  
        initPrices() {
  
          // Classic price
  
          const thisPrice = this.querySelector('[data-product-sticky-price-regular]');
          const defaultPrice = document.querySelector('[data-main-product-price] .price_item--regular');
  
          if (thisPrice !== null && thisPrice !== undefined && defaultPrice !== null && defaultPrice !== undefined) {
  
            const cloneDefaultPrice = defaultPrice.cloneNode(true);
  
            // Insert in DOM
            thisPrice.innerHTML = '';
            thisPrice.appendChild(cloneDefaultPrice);
            
          }
  
          // Sale price
  
          const thisSalePrice = this.querySelector('[data-product-sticky-price-sale]');
          const defaultSalePrice = document.querySelector('[data-main-product-price] .price_item--sale');
  
          if (thisSalePrice !== null && thisSalePrice !== undefined && defaultSalePrice !== null && defaultSalePrice !== undefined && !defaultSalePrice.classList.contains('price_item--regular')) {
  
            const cloneDefaultSlaePrice = defaultSalePrice.cloneNode(true);
  
            // Insert in DOM
            thisSalePrice.innerHTML = '';
            thisSalePrice.appendChild(cloneDefaultSlaePrice);
            
          }
  
          // Club price
  
          const thisClubPrice = this.querySelector('[data-product-sticky-club-price]');
          const defaultClubPrice = document.querySelector('[data-main-product-price] > .price--club');
  
          if (thisClubPrice !== null && thisClubPrice !== undefined && defaultClubPrice !== null && defaultClubPrice !== undefined) {
  
            const cloneDefaultClubPrice = defaultClubPrice.cloneNode(true);
  
            // Insert in DOM
            thisClubPrice.innerHTML = '';
            thisClubPrice.appendChild(cloneDefaultClubPrice);
            thisClubPrice.classList.add('active');
  
          }
          
          // On default change
          this.onDefaultPricesChange();
  
        }
  
        onDefaultPricesChange() {
  
          // DOM observer
          const observeDOM = (function(){
            let MutationObserver = window.MutationObserver || window.WebKitMutationObserver;
  
            return function( obj, callback ){
              if( !obj || obj.nodeType !== 1 ) return; 
  
              if( MutationObserver ){
                // define a new observer
                let mutationObserver = new MutationObserver(callback)
  
                // have the observer observe foo for changes in children
                mutationObserver.observe( obj, { childList:true, subtree:true })
                return mutationObserver
              }
              
              // browser support fallback
              else if( window.addEventListener ){
                obj.addEventListener('DOMNodeInserted', callback, false)
                obj.addEventListener('DOMNodeRemoved', callback, false)
              }
            }
          })();
  
          const _this = this;
  
          const defaultPrices = document.querySelector('[data-main-product-price]');
  
          if (defaultPrices !== null && defaultPrices !== undefined) {
            observeDOM(defaultPrices, function(m){
              _this.initPrices();
            });
          }
  
        }
  
      },
    );
  }

});
